import React, { Component } from 'react'
import Divider from '@material-ui/core/Divider';
import LogoutButton from './LogoutButton'
import { withStyles } from '@material-ui/core/styles';
import logo from '../icons/logo.png';
import IdleTimer from 'react-idle-timer'
import { Redirect } from 'react-router-dom'

const styles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 70
  },
  logo: {
    padding: 20
  },
  actions: {},
  alert: {
    padding: 20,
    borderLeft: '1px solid #eaeaea'
  }
}

class Header extends Component {
  onIdle = e => {
    if (process.env.REACT_APP_HOST == 'NETLIFY') {
        window.location.assign('https://webapp.dev.alacrityps.com/logout')
    } else {
        window.location.assign('/logout')
    }
  }

  render() {
    const { classes } = this.props

    return (
      <div>
        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          element={document}
          onIdle={this.onIdle}
          debounce={250}
          timeout={60 * 20 * 1000} />
        <div className={classes.header}>
          <div className={classes.logo}>
            <a href="/patients"><img src={logo} alt="logo"/></a>
          </div>
          <LogoutButton username="Admin" />
        </div>
        <Divider />
      </div>
    )
  }
}

export default withStyles(styles)(Header)



// WEBPACK FOOTER //
// ./src/components/Header.js